export default "__VITE_ASSET__C5Ws0RRL__"